import { IconType, SvgIcon } from './SvgIcon';

export const AvatarPlaceholder: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 50 50">
    <g clipPath="url(#clip0_1871_25368)">
      <rect width="50" height="50" rx="25" fill="#2540F5" fillOpacity="0.1" />
      <circle cx="25" cy="21" r="9" fill="white" />
      <circle cx="25" cy="50" r="18" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_1871_25368">
        <rect width="50" height="50" rx="25" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

AvatarPlaceholder.displayName = 'AvatarPlaceholder';
